module.exports = __webpack_public_path__ + "assets/img/ulu pandan 84m.186c6c23.jpg";